import React from 'react'
import { useParams } from 'react-router-dom'
import { Row } from 'antd'
import moment from 'moment'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'

const FoodTracking = () => {
    const { id } = useParams()
    return (
        <>
            <div>
                <Heading>Food Tracking</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Pet_Food_tracking.getAll,
                            extraQuery: {
                                petId: id
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `PF${data?.id.toString().padStart(7, "0")}`,
                                        mealDate: moment(data?.timeOfMeal).format("DD MMM YYYY"),
                                        mealTime: moment(data?.timeOfMeal).format("hh:mm:ss A"),

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.PETS_FOOD_TRACKING,
                        }}
                        isSearch={true}

                    />
                </Row>

            </div>
        </>
    )
}

export default FoodTracking